module.exports = __webpack_public_path__ + "media/conversa/logo_Conversa_Color-3ef2c12a.png";